import permissions from 'constants/permissions'

const LEGITIMATE_INTEREST_LIST = [
  {
    name: 'Listar processos LIA',
    tag: permissions.LEGITIMATE_INTEREST.LIST,
  },
  {
    name: 'Visualizar processos LIA',
    tag: permissions.LEGITIMATE_INTEREST.SHOW,
  },
  {
    name: 'Gerenciar respostas LIA',
    tag: permissions.LEGITIMATE_INTEREST.MANAGE,
  },
  {
    name: 'Usar template de respostas LIA',
    tag: permissions.LEGITIMATE_INTEREST.USE_TEMPLATE,
  },
]

export default LEGITIMATE_INTEREST_LIST
